import React from "react";

import { useTranslation } from "react-i18next";

import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { EventContentTab } from "@features/offer/shared/event";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { observer } from "mobx-react";
import { analyticsTracker } from "@utils/analytics";
import { SportStatisticsTypeEnum } from "@data-types/analytics-tracker/SportsStatisticsInteractionTypeEnum";

export const TeamLineupsButton = observer(function TeamLineupsButton(props: {
	store: EventViewStore | AdditionalOfferViewStore;
}) {
	const { t } = useTranslation();

	return (
		<EventContentTab
			textContent={t("EVENT.HEADER.TEAM_LINEUPS")}
			isActive={
				props.store.displayStatisticsGroup ===
				StatisticsGroups.TeamLineups
			}
            onClick={() => {
			    if (
					props.store.displayStatisticsGroup !==
					StatisticsGroups.TeamLineups
				) {
					analyticsTracker.trackSportStatisticsInteractionTracking(
						SportStatisticsTypeEnum.TeamLineupsVisit
					);
					props.store.setDisplayStatisticsGroup(
						StatisticsGroups.TeamLineups
					);
				}
			}}
			hasNewTag
		/>
	);
});
